import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=e57c76b6&scoped=true&"
import script from "./Start.vue?vue&type=script&lang=ts&"
export * from "./Start.vue?vue&type=script&lang=ts&"
import style0 from "./Start.vue?vue&type=style&index=0&id=e57c76b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57c76b6",
  null
  
)

export default component.exports